module.exports = __webpack_public_path__ + "static/media/vf_mjumperjacket_core.68020abd.svg";